import styled from '@emotion/styled';

export const SadaKFormModal = styled.div``;
